export default {
  employee: {
    name: 'employees',
    value: (row) =>
      [row.employee_code, row.firstname, row.initials, row.surname_prefix, row.surname]
        .filter((e) => e)
        .join(' '),
    identifier: 'uuid',
    query: ['Active', 'Pause', 'FormerEmployee']
      .map((state) => 'employee_status[]=' + state)
      .join('&')
  },
  user: {
    name: 'users',
    value: (row) => {
      const name = row.display_name || row.email;
      return row.active === false ? `${name} (inactief)` : name;
    },
    identifier: 'uuid',
    query: 'n=20'
  },
  campaign: {
    name: 'campaigns',
    value: (row) =>
      [row.client.name, row.name].join(' ') + (row.enabled === false ? ' (inactief)' : ''),
    identifier: 'id'
  },
  location: {
    name: 'locations',
    value: (row) => row.name,
    identifier: 'id',
    public: true
  },
  applyLocation: {
    name: 'locations',
    value: (row) => row.name,
    identifier: 'id',
    query: 'enabled=1&n=1000',
    public: true
  }
};
